import { call, put, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga'
import { REQUEST_SORT_TYPES_CINEMA_SCHEDULE, REQUEST_MOVIES_BY_CINEMA, REQUEST_SCHEDULE_MOVIES_ALL, REQUEST_MOVIES_BY_CINEMA_ID } from "../actions/types";
import { getMoviesByCinemaApi, getAllMoviesForSchedule, getMoviesByCinemaIdApi, getMovieTheaterDetails } from '../api/schedule.api';
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import { GENERIC_ERROR_MESSAGE } from "../config/messages";
import {
    requestMoviesByCinemaSuccess,
    requestMoviesByCinemaFailed,
    requestScheduleMoviesAllSuccess,
    requestScheduleMoviesAllFailed,
    requestSortTypesOnCinemaScheduleSuccess,
    requestSortTypesOnCinemaScheduleFailed,
    requestMoviesByCinemaIdSuccess,
    requestMoviesByCinemaIdFailed
} from '../actions/schedule.actions';
import { showSpinner, hideSpinner } from "../actions/loading.actions";

function* getMoviesByCinema(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getMoviesByCinemaApi, action.payload);
        let index = -1;
        let sortIndex = -1;
        // Create new property with hours and ids, beacause on design it`s an custom select, and for indexing and other properties we need an object
        response.data.forEach(function (item) {
            item.schedule.forEach(schedule => {
                for (let i = 0; i < schedule.schedule_broadcast_hours.length; i++) {
                    schedule.schedule_broadcast_hours[i].isSelected = false;
                    schedule.schedule_broadcast_hours[i].id = i;
                }
            });
            // End create new properties for hours

            if (action.payload.id > 0) {
                index++;
                if (action.payload.id === item.cinema.cinema_id) {
                    sortIndex = index;
                }
            }
        });
        let movies = response.data;
        
        // for (let i = 0; i < 32; i++) {
        //     movies[0].schedule.push(movies[0].schedule[0]);
        // }

        //order response by cinema details
        if (sortIndex > -1) {
            let firstElement = movies[0];
            movies[0] = movies[sortIndex];
            movies[sortIndex] = firstElement;
        }
        if (response.status) {
            yield put(hideSpinner());
        }

        if (response.status === 200) {
            yield put(requestMoviesByCinemaSuccess(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000)
        yield put(hideGeneralError(''));
    }
}
/// This call it`s not used beacuse api response it`s different 
function* getMoviesByCinemaId(action) {
        try {
            yield put(showSpinner());
            const responseMovies = yield call(getMoviesByCinemaIdApi, action.payload);
            const responseCinema = yield call(getMovieTheaterDetails, action.payload.id);
            if (responseMovies.status) {
                yield put(hideSpinner());
            }

            if (responseMovies.status === 200) {
                let response = []
                if (responseMovies.data.length !== 0){
                    response = [ 
                        {
                            cinema: responseCinema.data,
                            schedule: responseMovies.data
                        }
                    ]       
                }
                yield put(requestMoviesByCinemaIdSuccess(response));
            } else {
                yield put(requestMoviesByCinemaIdFailed('Error'));
                //TODO: Success false 
            }
        } catch (e) {
            yield put(hideSpinner());
            yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
            yield call(delay, 5000)
            yield put(hideGeneralError(''));
        }
}

function* getAllMovies(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getAllMoviesForSchedule, action.payload);
        // console.log(response.data);
        // response.data.forEach(function (item) {
        //     item.film.stars = '';
        //     if (item.film.film_cast.length > 0) {
        //         item.film.film_cast.forEach(function (cast) {
        //             item.film.stars += cast.celebrity_name + ', ';
        //         });
        //         item.film.stars = item.film.stars.substring(0, item.film.stars.length - 2);
        //     }
        // });
        let scheduleAllMovies = response.data;

        if (response.status) {
            yield put(hideSpinner());
        }
        
        if (response.status === 200) {
            yield put(requestScheduleMoviesAllSuccess(scheduleAllMovies));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000)
        yield put(hideGeneralError(''));
    }
}

function* getSortTypesOnCinemaSchedule(action) {
    try {
        // const response = yield call(getSortTypesFromApi, action.payload);

        //Simulate api call
        const response = {};
        response.success = true;
        response.data = [{
            id: 1,
            value: 'Cele mai noi'
        }, {
            id: 2,
            value: 'Cele mai vechi'
        }];

        if (response.success) {
            yield put(requestSortTypesOnCinemaScheduleSuccess({ filters: response.data }));
        } else {
            yield put(requestSortTypesOnCinemaScheduleFailed('Error'));
            //TODO: Success false 
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000)
        yield put(hideGeneralError(''));
    }
}

export default function* scheduleSaga() {
    yield takeLatest(REQUEST_SORT_TYPES_CINEMA_SCHEDULE, getSortTypesOnCinemaSchedule);
    yield takeLatest(REQUEST_MOVIES_BY_CINEMA, getMoviesByCinema);
    yield takeLatest(REQUEST_SCHEDULE_MOVIES_ALL, getAllMovies);
    yield takeLatest(REQUEST_MOVIES_BY_CINEMA_ID, getMoviesByCinemaId);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/schedule.saga.js